import React, { useContext, useState, useEffect } from "react";
import { AppContext } from '../../../services/AppContext';
import { useTranslation } from 'react-i18next';

const ReduceSubscription = ({ closeModal, subscriptionDto }) => {
    const { t } = useTranslation();
    const { apiClient, notify, user } = useContext(AppContext);
    const [selectedManager, setSelectedManager] = useState();
    const [managersData, setManagersData] = useState();

    const fetchData = async () => {
        if (user.role !== 'Admin') {
            return;
        }

        const now = new Date();
        const month = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, 0, 0, 0)).toISOString();
        const until = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0)).toISOString();

        const data = await apiClient.getManagers({
            from: month,
            to: until
        });

        if (!data.hasErrors) {
            setManagersData(data);
            setSelectedManager(data[0]?.id);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleManagerChange = (e) => {
        setSelectedManager(e.target.value);
    };

    const handleConfirm = async () => {
        try {
            const spentClassResult = await apiClient.spendClass({ subscriptionId: subscriptionDto.id, managerId: selectedManager });

            if (!spentClassResult.hasErrors) {
                let message = t('pages.customers.modals.successRegistered', { remaining: spentClassResult.after});

                if (spentClassResult.after === 0) {
                    message = t('pages.customers.modals.subscriptionOver');
                }

                notify(message, "success");
            }

            closeModal(true);
        } catch (error) {
            notify(error.message, "error");
        }
    };

    const handleCancel = () => {
        closeModal(false);
        setSelectedManager();
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>{t('pages.customers.modals.pickManager')}</h3>

                {managersData && (
                    <div className="mg-b-1">
                        <select
                            id="manager"
                            value={selectedManager}
                            onChange={handleManagerChange}
                        >
                            {managersData.map(manager => (
                                <option key={manager.id} value={manager.id}>
                                    {manager.name}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                <div className="container">
                    <button className="mg-r-1 width-100p" onClick={handleConfirm}>
                        {t('pages.customers.modals.confirmButton')}
                    </button>
                    <button className="width-100p" onClick={handleCancel}>
                        {t('pages.customers.modals.cancelButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReduceSubscription;